import { LOCATIONS } from "@/content/locations";

/**
 * Programmable city × service pages. We deliberately restrict which
 * service slugs are combinable with a city so we only ever ship pages
 * that carry a distinct, useful playbook — not thin doorway pages.
 */
export const PROGRAMMABLE_SERVICE_SLUGS = [
  "local-seo",
  "technical-seo-audit",
  "ecommerce-seo",
  "aeo-geo",
  "content-strategy",
] as const;

export type ProgrammableServiceSlug = (typeof PROGRAMMABLE_SERVICE_SLUGS)[number];

export function isProgrammableService(slug: string): slug is ProgrammableServiceSlug {
  return (PROGRAMMABLE_SERVICE_SLUGS as readonly string[]).includes(slug);
}

/** Enumerate every valid city × service combination for the sitemap. */
export function programmableCityServicePaths(): string[] {
  const out: string[] = [];
  for (const loc of LOCATIONS) {
    for (const svc of PROGRAMMABLE_SERVICE_SLUGS) {
      out.push(`/seo-services/${loc.slug}/${svc}`);
    }
  }
  return out;
}
